import React, { useEffect } from "react";
import { VirusSpawnerConstants } from "../../../shared/constants";
import { GameClient } from "../gameClient";
import { Colors } from "../palettes/colorPalette";
import { backgroundTexture } from "../uiConstants";

declare var gameClient: GameClient;

const modelStyle: React.CSSProperties = {
	position: "absolute",
	color: Colors.UITextAndBorders,
	width: "30vw",
	paddingBottom: "2vh",
	background: `url(${backgroundTexture})`,
	backgroundColor: Colors.UIBackground,
	textShadow: "none",
	textAlign: "center",
	borderRadius: "10pt",
	border: `solid 3px ${Colors.UITextAndBorders}`,
	top: "12%",
	left: "32%",
	paddingLeft: "10px",
	paddingRight: "10px",
	fontSize: "1vw"
}

type TiebreakerModalProps = {
	tiebreakerNumber: number;
};

export const TiebreakerModal = (props: TiebreakerModalProps) => {
	useEffect(() => {
		const mouselistener = (event: MouseEvent) => {
			gameClient.onConfirmVirusGrowth();
		}

		document.addEventListener('click', mouselistener);
		return () => {
			document.removeEventListener('click', mouselistener);
		};
	})

	const round = props.tiebreakerNumber;
	let header: string;
	switch (round) {
		case 0:
			header = `Tiebreaker!`;
			break;
		case 1:
			header = `Double Tiebreaker!`;
			break;
		case 2:
			header = `FINAL TIEBREAKER!`;
		default:
			header = `Tiebreaker Round ${round + 1}`;
	}

	return <div id="mutation-modal" style={modelStyle}>
		<h2>{header}</h2>
		<p />
		{`No player took damage, so more viruses will spawn until someone does! ${round > 1 ? `${round}/${VirusSpawnerConstants.BattleRoundGrowthProgression.length}` : ""}`}
		<p />
		{gameClient.showVirusGrowthDisplay && <div style={{ color: Colors.UIUnemphasizedText, marginTop: "0.5vh", fontSize: "0.8em" }}>Click to proceed</div>}
	</div >
}
